// Libraries
import { Box, Typography } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";

// Custom
import { EditVariants } from "Custom/StylesAppSpecific/EditVariants";
import { TypographyVariants } from "Custom/StylesAppSpecific/TypographyVariants";
import { EmailStyle } from "./EmailStyle";
import EmailViewModel from "Custom/ViewModels/ProductSelector/SubViewModels/EmailViewModel";
import { BQSButton } from "Custom/Views/Primitives/Buttons/BQSButton";
import { BQSEdit } from "Custom/Views/Primitives/Edits/BQSEdit";
import { BQSRow } from "Custom/Views/Primitives/Row/BQSRow";
import { ProductSelectorModel } from "Custom/Models/Domain/ProductSelector/ProductSelectorModel";

interface IProps {
    className?: string;
    canExecuteSend: boolean;
    sendEmail: () => Promise<void>;
    productSelectorModel: ProductSelectorModel;
}

export const Email: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const [viewModel] = useState(() => new EmailViewModel(props.sendEmail, props.productSelectorModel));

    const editVariants = EditVariants();
    const typopgraphyVariants = TypographyVariants();
    const emailStyle = EmailStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={emailStyle.root}>
            <Typography className={typopgraphyVariants.productSelectorh2} variant="h2">
                Request Quotation
            </Typography>
            <Typography className={typopgraphyVariants.productSelectorbody1}>Request a quotation from the Sharmans' Support team.</Typography>
            <BQSRow className={emailStyle.bqsEditRow}>
                <BQSEdit
                    key="projectName"
                    className={editVariants.bqsEditFlex}
                    displayName="Project name to associate with this quote *"
                    placeholder="Project name"
                    value={viewModel.model.projectName}
                    execute={viewModel.setProjectName}
                    validationMessage={viewModel.projectNameError}
                />
                <BQSButton canExecute={props.canExecuteSend} className={emailStyle.bqsButton} displayName="Request Quotation" execute={viewModel.sendEmail} />
            </BQSRow>
            <Typography className={typopgraphyVariants.productSelectorbody1}>
                For further support, please contact our Sales team: Email <a href="mailto:info@hdsharman.co.uk">info@hdsharman.co.uk</a> or call{" "}
                <a href="tel:01298 875003">01298 875003</a>.
            </Typography>
        </Box>
    ));

    // #endregion Render Result
};
